import { ValidationError } from '@src/components/ValidationError';
import { useTranslation } from 'react-i18next';
import type { ComboboxMultipleProperties } from '../ComboboxMultiple';

export type ComboboxErrorProperties<T> = Pick<
  ComboboxMultipleProperties<T>,
  'showError'
> & {
  isValid: boolean;
  failedToAddOption: boolean;
  errorMessage: string | undefined;
};

export function ComboboxError<T>({
  isValid,
  failedToAddOption,
  errorMessage,
  showError,
}: ComboboxErrorProperties<T>) {
  const { t } = useTranslation('errorMessages');
  const { t: tValidation } = useTranslation('formValidation');

  if (!showError) {
    return null;
  }

  return (
    <ValidationError
      isValid={isValid && !failedToAddOption}
      errorMessage={
        failedToAddOption
          ? t('failedToAddOption')
          : (errorMessage ?? tValidation('invalidInput'))
      }
    />
  );
}
